import { render, staticRenderFns } from "./CalcResultParams.vue?vue&type=template&id=47e97148&scoped=true&"
import script from "./CalcResultParams.vue?vue&type=script&lang=js&"
export * from "./CalcResultParams.vue?vue&type=script&lang=js&"
import style0 from "./CalcResultParams.vue?vue&type=style&index=0&id=47e97148&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e97148",
  null
  
)

export default component.exports